// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// 🔗  'llevaA' debe coincidir con el nombre de otra sección
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const INICIO = {
  mensaje: 'Selecciona el tema sobre el que necesitas ayuda:',
  opciones: [
    { boton: '📋 Módulos del sistema',     llevaA: 'modulos'  },
    { boton: '🔑 Problemas de acceso',      llevaA: 'acceso'   },
    { boton: '📊 Reportes y exportaciones', llevaA: 'reportes' },
    { boton: '🎨 Temas y apariencia',       llevaA: 'temas'    },
    {
      boton: '🏢 Cambiar sucursal',
      respuesta: 'Para cambiar de sucursal, haz clic en el ícono de usuario en la esquina superior derecha del menú y selecciona "Cambiar sucursal".',
    },
  ],
}
